<template>
  <div
    class="pane-tray"
    :class="{
      'pane-tray--expandable': expandable,
      'pane-tray--expanded': expanded
    }"
  >
    <Transition name="transition-side-right">
      <div
        v-if="isOpen"
        class="pane-tray__container"
      >
        <slot name="header">
          <div
            v-if="showHeader"
            class="pane-tray__header"
          >
            <div
              v-if="heading"
              class="pane-tray__header__heading"
            >
              {{ heading }}
            </div>

            <div
              v-if="$slots.headerPlus"
              class="pane-tray__header__plus"
            >
              <slot name="headerPlus"></slot>
            </div>
          </div>
        </slot>

        <div class="pane-tray__body">
          <slot name="body"></slot>
        </div>

        <button
          v-if="expandable"
          class="pane-tray__button pane-tray__button--expand"
          @click.prevent="toggleExpand"
        >
          <SvgIconExpand/>
        </button>

        <button
          class="pane-tray__button pane-tray__button--close"
          @click.prevent="close"
        >
          <SvgIconClose/>
        </button>

        <slot name="footer" />
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'BasePaneTray',

  props: {
    context: {
      type: String,
      default: 'defaultContext'
    },
    isOpen: Boolean,
    heading: {
      type: String,
      required: false
    },
    expandable: Boolean
  },

  data () {
    return {
      expanded: false
    }
  },

  computed: {
    showHeader () {
      return this.heading || this.$slots.headerPlus
    }
  },

  methods: {
    close () {
      this.$root.$emit('pane-tray-close', this.context)
    },

    toggleExpand () {
      this.expanded = !this.expanded

      this.$root.$emit('pane-tray-expanded', this.expanded)
    }
  }
}
</script>

<style lang="scss" scoped>
.pane-tray {
  $border: 2px solid nth($colors-custom, 4);

  z-index: 10;
  position: fixed;
  top: 0;
  right: 0;

  &--expandable & {
    &__header {
      &__plus {
        &:first-child {
          margin-right: 70px;
        }
      }
    }
  }

  &--expanded & {
    &__container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    }
  }

  &__container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 370px;
    height: 100vh;
    border-left: $border;
    background: #fff;
  }

  &__header {
    position: relative;
    padding: 20px;
    border-bottom: $border;

    &__plus {
      &:first-child {
        padding-right: 30px;
      }

      &:not(:first-child) {
        margin-top: 20px;
      }
    }

    &__heading {
      font: {
        weight: 700;
        size: 16px;
      }
    }
  }

  &__body {
    @extend %scrollbar;

    flex-grow: 1;
    padding: 20px;
    overflow: auto;
  }

  &__button {
    position: absolute;
    top: 20px;
    display: inline-block;
    padding: 0;
    border: 0;
    background: none;

    svg {
      width: 16px;
      fill: rgba(nth($colors-custom, 1), 0.8);
    }

    &--close {
      right: 20px;
    }

    &--expand {
      right: 60px;
    }
  }
}
</style>
